/**
 * Libraries every page needs loaded before its own code runs.
 *
 * The test for belonging here is a one-time side effect, not availability.
 * `vendorJS/modernizr` assigns the `Modernizr` global that
 * `import Modernizr from 'modernizr'` resolves to, and writes the feature
 * classes onto `<html>`; `Rails.start()` installs the delegated handlers behind
 * `data-confirm`, `data-method` and `data-remote`, and must run exactly once.
 * Anything that merely needs to be available is imported where it is used.
 */
const Rails = require('@rails/ujs').default;
require('vendorJS/modernizr');

// Delegated `data-confirm`, `data-method` and `data-remote` handlers on
// `document`.
Rails.start();
